import {GdkUtils} from './index';

// @dynamics
export class GdkInfoPage {
  public static settitle(name: string = ''): void {
    setTimeout(() => {
      const t = document.getElementById('tootbar');
      if (t != null) {
        t.innerText = name;
      }
    });

  }

  public static menuToolbar(): any[] {
    return this.getInfo() ? this.getInfo().toolbar : [];
  }

  public static getMenuNav(): any[] {
    const nav = this.getInfo() ? this.getInfo().menu : [];
    if (nav.length) {
      const _nav = GdkUtils.TrfMenu(nav, 'id', 'cap_tren', 'goc', 'goc');
      return _nav;
    }
    return [];
  }

  public static getHome(): string {
    return this.getInfo() ? this.getInfo().home : '/';
  }

  public static getLogin(): string {
    return this.getInfo() ? this.getInfo().login : '/';  // sessionStorage.getItem('login') || '/';
  }

  public static setToken(v): void {
    sessionStorage.setItem('token', v);
  }

  public static getToken(): string {
    return sessionStorage.getItem('token') || '';
  }


  public static clearAll() {
    sessionStorage.clear();
    localStorage.clear();

  }

  public static setInfo(v: any): void {
    if (v) {
      // console.log('v', v);
      const info$ = btoa(unescape(encodeURIComponent(JSON.stringify(v))));
      //  console.log(info$);
      sessionStorage.setItem('info', info$);

    }
  }

  public static getInfo(): any {
    const info = sessionStorage.getItem('info');
    if (info) {

      const info$ = decodeURIComponent(escape(atob(info)));
      // console.log(info$);
      const _info$ = JSON.parse(info$);
      const _info$$ = typeof _info$ === 'string' ? JSON.parse(_info$) : _info$;
      //   console.log(_info$$, _info$$.home);
      return _info$$;
    }
    return null;
  }


}
